import React, {useContext, useEffect, useState} from "react"
import {Page, Text, View, Document, StyleSheet, PDFViewer, Font} from '@react-pdf/renderer';
import { useLocation } from "react-router-dom";
import RobotoRegular from "../assets/fonts/Roboto-Regular.ttf";
import RobotoItalic from "../assets/fonts/Roboto-Italic.ttf";
import RobotoBoldItalic from "../assets/fonts/Roboto-BoldItalic.ttf";
import RobotoBold from "../assets/fonts/Roboto-Bold.ttf";
import ProjectContext from "../utils/context";
import {DataTableCell, Table, TableBody, TableCell, TableHeader} from "@david.kucsai/react-pdf-table";
import {euroFormat} from "../utils/usefullFunctions"; // Dit is de PDF generator library


// Utility function to format dates
const formatDate = (dateString) => {
    if (!dateString) return "Not Available";
    try {
        return new Intl.DateTimeFormat("nl-NL", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        }).format(new Date(dateString));
    } catch (error) {
        console.error("Invalid date:", dateString);
        return "Invalid Date";
    }
};

function TotalenPrint() {
    const {project} = useContext(ProjectContext)



    const service_form_project_hours_cost = project.service_form_project_hours_cost;
    const service_form_project_hour_tariffs = project.service_form_project_hour_tariffs;
    const service_form_project_articles_cost = project.service_form_project_articles_cost;
    const service_form_project_risc = project.service_form_project_risc;
    const service_form_project_products_cost = project.service_form_project_products_cost;
    const service_form_project_hardware_cost = project.service_form_project_hardware_cost;
    const service_form_project_data_total = project.service_form_project_data_total;
    const [dataSource, setDataSource] = useState([]);
    const [dataSource2, setDataSource2] = useState(service_form_project_data_total);
    const [totals, setTotals] = useState();

    const { state } = useLocation();

    useEffect(() => {
        setDataSource([
            {
                id: 0,
                name: "DDC",
                tarif: service_form_project_hour_tariffs.oh.cost,
                total: Math.ceil(service_form_project_hours_cost.ohddc / service_form_project_hour_tariffs.oh.cost),
            },
            {
                id: 1,
                name: "VELD",
                tarif: service_form_project_hour_tariffs.oh.cost,
                total: Math.ceil(service_form_project_hours_cost.ohveld / service_form_project_hour_tariffs.oh.cost),
            },
            {
                id: 2,
                name: "PL",
                tarif: service_form_project_hour_tariffs.pl.cost,
                total: Math.ceil((service_form_project_hours_cost.pl + service_form_project_articles_cost.storing?.cost) / service_form_project_hour_tariffs.pl.cost),
            },
            {
                id: 3,
                name: "BOA",
                tarif: service_form_project_hour_tariffs.boa.cost,
                total: Math.ceil((service_form_project_hours_cost.boaBasis + service_form_project_hours_cost.boa + service_form_project_hours_cost.energy) / service_form_project_hour_tariffs.boa.cost),
            },
        ])
    }, [service_form_project_hours_cost, service_form_project_hour_tariffs, service_form_project_articles_cost])

    useEffect(() => {
        console.log(dataSource2, "dats")
        const t = dataSource2.reduce((prev, curr) => {
            prev.cost = prev.cost + parseFloat(curr.cost || 0)
            prev.sale = prev.sale + parseFloat(curr.sale || 0)
            return prev
        }, {
            cost: 0,
            sale: 0,
        })
        // risico toevoegen
        t.risc = t.cost * (parseInt(service_form_project_risc) / 100)
        t.margin = parseFloat((t.sale - (t.cost + t.risc)) / t.sale) * 100

        setTotals({
            cost: t.cost,
            sale: t.sale,
            margin: t.margin,
            risc: t.risc
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataSource2])

    useEffect(() => {
        let data = [...dataSource2]

        data[0].cost = service_form_project_hours_cost.ohddc;
        data[0].sale = service_form_project_hours_cost.ohddc / (1 - service_form_project_hour_tariffs.oh.margin);
        data[0].margin = service_form_project_hour_tariffs.oh.margin;

        data[1].cost = service_form_project_hours_cost.ohveld;
        data[1].sale = service_form_project_hours_cost.ohveld / (1 - service_form_project_hour_tariffs.oh.margin);
        data[1].margin = service_form_project_hour_tariffs.oh.margin;

        data[2].cost = service_form_project_hours_cost.pl;
        data[2].sale = service_form_project_hours_cost.pl / (1 - service_form_project_hour_tariffs.pl.margin);
        data[2].margin = service_form_project_hour_tariffs.pl.margin;

        data[3].cost = service_form_project_hours_cost.boaBasis;
        data[3].sale = service_form_project_hours_cost.boaBasis / (1 - service_form_project_hour_tariffs.boa.margin);
        data[3].margin = service_form_project_hour_tariffs.boa.margin;

        data[4].cost = service_form_project_hours_cost.boa;
        data[4].sale = service_form_project_hours_cost.boa / (1 - service_form_project_hour_tariffs.boa.margin);
        data[4].margin = service_form_project_hour_tariffs.boa.margin;

        data[5].cost = service_form_project_hours_cost.energy;
        data[5].sale = service_form_project_hours_cost.energy / (1 - service_form_project_hour_tariffs.boa.margin);

        if (service_form_project_articles_cost) {
            data[6].cost = service_form_project_articles_cost.cloud.cost;
            data[6].sale = service_form_project_articles_cost.cloud.sale;
            data[6].margin = parseFloat((service_form_project_articles_cost.cloud.sale - service_form_project_articles_cost.cloud.cost) / service_form_project_articles_cost.cloud.sale);

            data[7].cost = service_form_project_articles_cost.vpn.cost;
            data[7].sale = service_form_project_articles_cost.vpn.sale;
            data[7].margin = 0.3;

            data[8].cost = service_form_project_articles_cost.storing.cost;
            data[8].sale = service_form_project_articles_cost.storing.sale;
            data[8].margin = ((service_form_project_articles_cost.storing.sale - service_form_project_articles_cost.storing.cost) / service_form_project_articles_cost.storing.sale);

            data[9].cost = service_form_project_articles_cost.storing24.cost;
            data[9].sale = service_form_project_articles_cost.storing24.sale;
            data[9].margin = ((service_form_project_articles_cost.storing24.sale - service_form_project_articles_cost.storing24.cost) / service_form_project_articles_cost.storing24.sale);

            data[10].cost = service_form_project_products_cost.cost;
            data[10].sale = service_form_project_products_cost.list;
            data[10].margin = parseFloat((service_form_project_products_cost.list - service_form_project_products_cost.cost) / service_form_project_products_cost.list);

            data[11].cost = service_form_project_hardware_cost.cost;
            data[11].sale = service_form_project_hardware_cost.sale;
            data[11].margin = parseFloat((service_form_project_hardware_cost.sale - service_form_project_hardware_cost.cost) / service_form_project_hardware_cost.sale);

        }
        setDataSource2(data)

    }, [service_form_project_hours_cost, service_form_project_articles_cost, service_form_project_products_cost, service_form_project_hardware_cost,
        service_form_project_hour_tariffs, service_form_project_risc])

    console.log(project)
    console.log(totals)
    if (!totals) return <></>
    return (<div className={"h-100 justify-content-center d-flex"}>
        <PDFViewer style={styles.viewer}>
            <Document title={"s-tool"}>
                <Page style={styles.body}>
                    <View fixed style={styles.topper}>
                        <View style={styles.topperCell}>
                            <Text>Calculatieblad
                                - {project.service_form_project_name} - {project.service_form_project_reference}</Text>
                        </View>
                    </View>

                    {/* Project info*/}
                    <View style={styles.table}>

                        <Table
                            data={[
                                {
                                    name: 'Project Type',
                                    value: project.project_type,
                                },
                                {
                                    name: 'Project Name',
                                    value: project.service_form_project_reference + " " + project.service_form_project_name,
                                },
                                {
                                    name: 'Customer reference person',
                                    value: `${project.service_form_project_firstname ?? ""} ${project.service_form_project_lastname ?? ""}`.trim(),
                                },
                                {
                                    name: 'Customer reference',
                                    value: project.order_number_customer,
                                },
                                {
                                    name: 'Project Group',
                                    value: project.project_group,
                                },
                                {
                                    name: 'Customer',
                                    value: project.service_form_project_account_name,
                                },
                                {
                                    name: 'Project Manager',
                                    value: project.service_form_project_firstname + " " + project.service_form_project_lastname,
                                },
                                {
                                    name: 'Sales Manager',
                                    value: project.service_form_project_seller,
                                },
                                {
                                    name: 'Offering Type',
                                    value: (project.calculation_type ? project.calculation_type : "Service"),
                                },
                                {
                                    name: 'Operational Unit',
                                    value: project.mobigo,
                                },
                                {
                                    name: 'Term of payment',
                                    value: project.project_term,
                                },
                                {
                                    name: 'VAT',
                                    value: project.project_btw,
                                },
                                {
                                    name: 'Order amount',
                                    value: Intl.NumberFormat('nl-NL', {
                                        style: 'currency',
                                        currency: 'EUR',
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0,
                                    }).format(project.service_form_project_total_sums.sale), //state.fact_total
                                },
                                {
                                    name: 'Start date',
                                    value: formatDate(project.assignment_date),
                                }
                            ]}
                        >
                            <TableHeader includeTopBorder={false} includeLeftBorder={false} includeRightBorder={false}
                                         fontSize={8} textAlign={"center"}>
                                <TableCell style={styles.headerLeft}>
                                    ProjectInfo
                                </TableCell>
                            </TableHeader>
                            <TableBody includeTopBorder={false} includeLeftBorder={false} includeRightBorder={false}
                                       includeBottomBorder={false} fontSize={8}>
                                <DataTableCell style={styles.cellText} getContent={(r) => r.name}/>
                                <DataTableCell style={styles.cellText} getContent={(r) => r.value}/>
                            </TableBody>
                        </Table>
                    </View>

                    <View style={styles.topperCell}>
                        <Text>Gebouwen</Text>
                        <Table style={styles.tableStyle} data={project.service_form_project_data_building}>
                            <TableHeader style={styles.tableStyle}>
                                <TableCell style={styles.tableStyleHeader}>
                                    {project.service_form_project_data_building.length > 1 ? "Gebouwen" : "Gebouw"}
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    BOA
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    OHDDC
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    OHVELD
                                </TableCell>
                            </TableHeader>
                            <TableBody>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.gebouw}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.boa}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.ohddc}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.ohveld}/>
                            </TableBody>
                        </Table>
                    </View>

                    <View style={styles.topperCell} break>
                        <Text>Uren</Text>
                        <Table style={styles.tableStyle} data={project.service_form_project_data_hour}>
                            <TableHeader style={styles.tableStyle}>
                                <TableCell style={styles.tableStyleHeader}>
                                    Naam
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    Uren
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    Correctie
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    Kost
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    Verkoop
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    Toelichting
                                </TableCell>
                            </TableHeader>
                            <TableBody>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.name}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.hours}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.corr}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => euroFormat(r.cost)}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => euroFormat(r.sale)}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.comment}/>
                            </TableBody>
                        </Table>
                    </View>

                    <View style={styles.topperCell}>
                        <Text>Abonnementen</Text>
                        <Table style={styles.tableStyle} data={project.service_form_project_data_articles}>
                            <TableHeader style={styles.tableStyle}>
                                <TableCell style={styles.tableStyleHeader}>
                                    Naam
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    Aantal
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    Kost
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    Verkoop
                                </TableCell>
                            </TableHeader>
                            <TableBody>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.name}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.amount}/>
                                <DataTableCell style={styles.tableStyleCell}
                                               getContent={(r) => r.amount ? euroFormat(r.cost) : ""}/>
                                <DataTableCell style={styles.tableStyleCell}
                                               getContent={(r) => r.amount ? euroFormat(r.sale) : ""}/>
                            </TableBody>
                        </Table>
                    </View>

                    <View style={styles.topperCell}>
                        <Text>Apparatuur</Text>
                        <Table style={styles.tableStyle} data={project.service_form_project_data_hardware}>
                            <TableHeader style={styles.tableStyle}>
                                <TableCell style={styles.tableStyleHeader}>
                                    Naam
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    Kost
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    Verkoop
                                </TableCell>
                            </TableHeader>
                            <TableBody>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.name}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => euroFormat(r.cost)}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => euroFormat(r.sale)}/>
                            </TableBody>
                        </Table>
                    </View>


                    <View style={styles.topperCell} break>
                        <Text>Prijsoverzicht</Text>
                        <Table style={styles.tableStyle} data={project.service_form_project_data_total}>
                            <TableHeader style={styles.tableStyle}>
                                <TableCell style={styles.tableStyleHeader}>
                                    Onderdeel
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    Kost
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    Verkoop
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    Marge
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    Toelichting
                                </TableCell>
                            </TableHeader>
                            <TableBody>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.name}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => euroFormat(r.cost)}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => euroFormat(r.sale)}/>
                                <DataTableCell style={styles.tableStyleCell}
                                               getContent={(r) => r.margin ? r.margin.toFixed(2) + "%" : ""}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.comment}/>

                            </TableBody>
                        </Table>
                    </View>


                    <View style={styles.topperCell}>
                        <Text>Totaal</Text>
                        <Table style={styles.tableStyle} data={[totals]}>
                            <TableHeader style={styles.tableStyle}>
                                <TableCell style={styles.tableStyleHeader}>
                                    Kost + risico
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    Risico
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    Verkoop
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    Marge
                                </TableCell>
                            </TableHeader>
                            <TableBody>
                                <DataTableCell style={styles.tableStyleCell}
                                               getContent={(r) => euroFormat(r.cost + r.risc)}/>
                                <DataTableCell style={styles.tableStyleCell}
                                               getContent={(r) => service_form_project_risc + "% risico " + euroFormat(r.risc)}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => euroFormat(r.sale)}/>
                                <DataTableCell style={styles.tableStyleCell}
                                               getContent={(r) => r.margin ? r.margin.toFixed(2) + "%" : ""}/>

                            </TableBody>
                        </Table>
                    </View>


                    {/*fix ff nog*/}
                    <View style={styles.topperCell}>
                        <Text>Urenoverzicht</Text>
                        <Table style={styles.tableStyle} data={dataSource}>
                            <TableHeader style={styles.tableStyle}>
                                <TableCell style={styles.tableStyleHeader}>
                                    Arbeid
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    Tarief
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader}>
                                    Totalen
                                </TableCell>

                            </TableHeader>
                            <TableBody>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.name}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => euroFormat(r.tarif)}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.total}/>

                            </TableBody>
                        </Table>
                    </View>
                </Page>
            </Document>
        </PDFViewer>
    </div>)
}

export default TotalenPrint


Font.register({
    family: 'Roboto', fonts: [
        {src: RobotoRegular}, // font-style: normal, font-weight: normal
        {src: RobotoItalic, fontStyle: 'italic'},
        {src: RobotoBoldItalic, fontStyle: 'italic-bold'},
        {src: RobotoBold, fontStyle: 'bold'},
    ]
});

// Removes hyphenation (-) <= dit ding
Font.registerHyphenationCallback(word => [word]);


const styles = StyleSheet.create(
    {
        h1: {
            fontSize: 22,
            fontFamily: "Roboto",
            fontStyle: "bold",
            margin: 0,
            padding: 0,
        },
        h2: {
            fontSize: 18,
            fontFamily: "Roboto",
            fontStyle: "bold",
            margin: 0,
            padding: 0,
        },
        h3: {
            fontSize: 14,
            fontFamily: "Roboto",
            fontStyle: "bold",
            margin: 0,
            padding: 0,
        },
        p: {
            // fontFamily: 'Roboto',
            fontSize: 10,
            margin: 0,
            justifyContent: "start",


        },
        strong: {
            fontFamily: "Roboto",
            fontStyle: "bold",
        },
        em: {
            fontFamily: "Roboto",
            fontStyle: "italic",
        },
        ol: {
            fontSize: 10
        },
        ul: {
            fontSize: 10
        },
        img: {
            width: 370,
            height: 300,
            margin: 0,
            padding: 0,
        },
        cellNumberAmount: {
            textAlign: 'center',
            fontFamily: 'Roboto',
            justifyContent: "start",
            paddingTop: 5,
        },
        header: {
            fontSize: 18,
            fontFamily: "Roboto",
            fontStyle: "bold",
            textDecoration: "underline",
            marginBottom: 15
        },
        headerNumber: {
            paddingVertical: 5,
            backgroundColor: '#eaeaea',
            fontFamily: "Roboto",
            fontStyle: "bold",
            fontSize: 11
        },
        headerText: {
            padding: 5,
            backgroundColor: '#eaeaea',
            fontFamily: "Roboto",
            fontStyle: "bold",
            fontSize: 11

        },
        headerTable: {
            fontSize: 14,
            fontFamily: "Roboto",
            fontStyle: "bold",
            marginBottom: 20
        },
        tableStyle: {
            // fontFamily: "Roboto",
            fontSize: 10,
            justifyContent: "start",
            marginBottom: 20,
        },
        tableStyleCell: {
            // fontFamily: "Roboto",
            fontSize: 10,
            justifyContent: "start",
            padding: 5,
        },
        tableStyleCellHeader: {
            fontSize: 16,
            justifyContent: "start",
            padding: 5,
        },
        tableStyleHeader: {
            // fontFamily: "Roboto",
            fontSize: 10,
            justifyContent: "start",
            padding: 5,
        },
        tableStyleGeneral: {
            border: 0,
            // fontFamily: "Roboto",
            fontSize: 10,
            justifyContent: "start"
        },
        tableStyleGeneralHeader: {
            border: 0,

            fontFamily: "Roboto",
            fontStyle: "bold",
            fontSize: 12,
            justifyContent: "start"
        },
        textInfo: {
            fontSize: 9,
            fontFamily: "Roboto",
            lineHeight: 1.3,
            color: '#8B8D8C',
            textAlign: "right"
        },
        textInfoBold: {
            fontSize: 9,
            fontFamily: "Roboto",
            fontStyle: "bold",
            lineHeight: 1.3,
            color: '#8B8D8C',
            textAlign: "right"

        },
        textBold: {

            fontFamily: "Roboto",
            fontStyle: "bold",
        },
        textBoldUnderline: {

            fontFamily: "Roboto",
            fontStyle: "bold",
            textDecoration: "underline"
        },
        title: {
            fontFamily: "Roboto",
            fontStyle: "bold",
            fontSize: 16,
            marginBottom: 10,
        },
        topper: {
            justifyContent: "space-between",
            flexDirection: "row",
            width: "100%",
            marginBottom: 25,
            color: "gray"
        },
        topperCell: {
            padding: 5,
            margin: 0,
        },
        body: {
            paddingTop: 35,
            paddingBottom: 65,
            paddingHorizontal: 45,
            fontFamily: 'Roboto',
            fontSize: 11

        },
        viewer: {
            width: "100%",
            height: "calc(100% - 40px)",
        },
        yconInfo: {
            width: 100
        },
        yconLogo: {width: 80, height: "auto"},
        unorderdList: {flexDirection: "row", marginBottom: 4},
        unorderdListBullet: {marginHorizontal: 8},
        unorderdListText: {width: "95%"}
    });
